import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { pillars, volumes, volumeIncludes } from '../data/volumes';
export function Volumes() {
  return <section aria-label="What is inside the ebook" className="bg-transparent" data-id="element-240" data-mp="184f1q1waxg7h">
      <div className="mx-auto max-w-6xl px-5 py-12" style={{
      paddingTop: '19px',
      paddingBottom: "21px"
    }} data-id="element-241" data-mp="1c5gr7r0f2dw9">
        <div className="text-center" data-id="element-242" data-mp="1zvb1q1x9jqdc">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-grape" data-id="element-243" data-mp="1zwcq183ai9d0">
            🌸 THE K-SMART VISUAL SYSTEM™
          </p>
          <h2 className="mt-3 font-display text-3xl font-black text-plum sm:text-4xl" data-id="element-244" data-mp="24rs2bvlnfx7b">
            What Will You Find Inside?
          </h2>
          <p className="mt-2 text-base text-plum/60" data-id="element-245" data-mp="1vsoj8rmhfhst">
            6 complete volumes · 120+ pages — Everything you need in one place.
          </p>
          <div className="mt-6 flex flex-wrap justify-center gap-2" data-id="element-246" data-mp="fhaqvgaj27ns">
            {pillars.map(p => <span key={p} className="rounded-full border border-grape/25 bg-lilac-soft px-3 py-1 text-xs font-bold uppercase tracking-wide text-plum-soft" data-id="element-247" data-mp="kfm1vuck6o7l">
                {p}
              </span>)}
          </div>
          <p className="mt-8 font-display text-lg font-black uppercase tracking-[0.18em] text-plum-soft" data-id="element-248" data-mp="3jb6j28yyn3l6">
            📚 The 6-Volume Method
          </p>
        </div>

        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-249" data-mp="3t6glgxt9tczh">
          {volumes.map((t, i) => <motion.article key={t.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.4,
          delay: i % 3 * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="group rounded-2xl border border-grape/15 bg-white p-5 transition-colors duration-200 ease-out hover:border-grape/45" style={{
          paddingTop: "10px",
          paddingBottom: "8px"
        }} data-id="element-250" data-mp="b0bxwnjylc7b" data-mpi={i}>
              <div className="flex items-center gap-3" data-id="element-251" data-mp="prkmctc4kriv">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-lilac-soft font-display text-lg font-black text-grape" data-id="element-252" data-mp="wtr6f87a3l3h">
                  {String(t.n).padStart(2, '0')}
                </span>
                <h3 className="text-sm font-bold leading-tight text-plum" data-id="element-253" data-mp="16rnaxh5pnhsm">
                  <span aria-hidden="true" data-id="element-254" data-mp="1bidi8zxp5upy">{t.emoji} </span>
                  {t.title}
                </h3>
              </div>
              <p className="mt-3 text-sm leading-relaxed text-plum/65" data-id="element-255" data-mp="1fj75dr3bf5hs">{t.desc}</p>
            </motion.article>)}
        </div>

        <div className="mt-10 rounded-2xl border border-grape/25 bg-white p-6" data-id="element-256" data-mp="1khqtny5dstdb">
          <p className="text-center font-display text-lg font-black text-grape" data-id="element-257" data-mp="1pjg359cygyza">
            ✅ Every volume includes
          </p>
          <ul className="mt-5 grid gap-3 sm:grid-cols-2 lg:grid-cols-4" data-id="element-258" data-mp="1uff0vnk6btcd">
            {volumeIncludes.map(item => <li key={item} className="flex items-start gap-2 text-sm text-plum/75" data-id="element-259" data-mp="3rbummcv5ebht">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-grape" strokeWidth={3} data-id="element-260" data-mp="3qitcinbanr" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}